// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__2396y","topBottomGutter":"Layout_topBottomGutter__2PgZ0"};